import React from "react";
import { FormattedNumber, FormattedMessage } from "react-intl";
import ProductPriceQuery from "./ProductPriceQuery.gql";
import { compose } from "recompose";
import { graphql } from "react-apollo";

export const currenciesWhitelist = ["EUR", "USD", "GBP", "CAD"];
export const currenciesAllowedList = currenciesWhitelist;

const ConvertedPrice = ({ price, ...props }) => {
  if (!price) {
    return null;
  }

  let value = price.value;
  price.amount = value?.amount * props.data.us_cad_conversion_rate;
  price.currency = "CAD";

  if (typeof props.data.us_cad_conversion_rate === "undefined") {
    return null;
  }

  return (
    <span className={`price price--converted`}>
      {price.amount === null ? (
        <FormattedMessage
          id="components.atoms.Typography.Price.notApplicable"
          defaultMessage="N/A"
        />
      ) : (
        <FormattedNumber
          value={price.amount}
          // eslint-disable-next-line react/style-prop-object
          style="currency"
          currency={price.currency}
        />
      )}
    </span>
  );
};

export default compose(
  graphql(ProductPriceQuery, {
    name: "data",
  })
)(ConvertedPrice);
